import React, { useState } from "react";
import { Input } from "antd";

const Search = ({ onSearch }) => {
    const [value, setValue] = useState("")

    const changeValue = (val) => {
        setValue(val)
        onSearch(val)
    }

    return (
        <Input
            placeholder="Buscar..."
            onChange={(e) => changeValue(e.target.value)}
            allowClear
        />
    );
};

export default Search;
